import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[blockEnter]',
    standalone: false
})
export class BlockEnterDirective {

  @Input('blockEnterAllowedId') allowedId: string | null = null;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    const target = event.target as HTMLElement;

    // Se for o campo permitido (CEP), deixa passar
    if (this.allowedId && target.id === this.allowedId) {
      return;
    }

    // Bloqueia ENTER globalmente
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }
}
